
import Vue from "vue";
import { showMore } from "../store/actions";
import { ITranslations } from "../store/state";
interface ShowMoreMethods {
  showMore(): void;
}
interface ShowMoreComputed {
  totalHits: number;
  showingHits: number;
  translations: ITranslations;
  shallShowMore: boolean;
  amountOfShowingHits: number;
}
export default Vue.extend<{}, ShowMoreMethods, ShowMoreComputed, {}>({
  name: "ShowMore",
  methods: {
    showMore() {
      this.$store.commit({
        type: "shouldFocus",
        payload: {
          shouldFocus: true,
          index: this.$store.getters.showingHits,
        },
      });
      this.$store.dispatch(showMore(undefined));
    },
  },
  computed: {
    totalHits() {
      let sum = 0;
      let showingHits = this.$store.getters.currentlyShowingHits;
      Object.keys(showingHits).forEach((key) => {
        sum += showingHits[key].length;
      });
      return sum;
    },
    showingHits() {
      return this.$store.getters.showingHits;
    },
    translations() {
      return this.$store.getters.translations;
    },
    shallShowMore() {
      return this.$store.getters.showMore;
    },
    amountOfShowingHits() {
      return this.$store.getters.amountOfShowingHits;
    },
  },
});
